export const footer = {
  contact: "Contact",
  phone1: "986 369 778",
  phone2: "676 367 580",
  email: "info@gandaraschool.com",
  address1: "Lugar de Moureira, 1, Mañufe",
  address2: "36388 Gondomar (Pontevedra)",
  schedule: "Horaires",
  weekdays: "Lundi à Vendredi",
  hours: "8h15 - 17h00",
  follow: "Suivez-nous",
  slogan: "Apprentissage expérientiel, trilingue et actif",
  theSchool: "L'École",
  admissions: "Admissions",
  activities: "Activités",
  viewOnMap: "Voir sur Google Maps",
  bookVisitCta: "Réserver une visite",
  allRightsReserved: "Tous droits réservés",
  links: {
    aboutUs: "À Propos",
    montessori: "Méthode Montessori",
    trilingual: "Éducation Trilingue",
    services: "Services",
    extracurriculars: "Activités Extrascolaires",
    admissionProcess: "Processus d'Admission",
    prices: "Tarifs",
    visitSchool: "Visiter l'École",
    openHouse: "Journée Portes Ouvertes",
    birthdays: "Anniversaires",
    easterCamp: "Camp de Pâques",
    summerCamp: "Camp d'Été",
    courses: "Cours"
  }
};
